<script lang="ts">
    import { mdiPencil } from "@mdi/js"
    import Icon from "../../../widgets/Icon.svelte"
    import CardWrapper from "../CardWrapper.svelte"
    import Input from "../../blocks/form/Input.svelte"
    import { appendErrorMessage, onChange, removeAllErrors, validateInput } from "../helper"
    import { login, newNotification } from "../../../../store"
    import { updateCustomer } from "../../../../functions/CommerceAPIs/bigCommerce/customer"
    import Select from "../../blocks/form/Select.svelte"
    import Calendar from "../../blocks/form/Calendar.svelte"
    export let customer: BigCommerceCustomer
    let editMode = false
    const birthday = (customer.form_fields || []).find((field) => field.name === "birthday")?.value
    const gender = (customer.form_fields || []).find((field) => field.name == "gender")?.value as "male" | "female"
    const personalData = {
        firstName: customer.first_name,
        lastName: customer.last_name,
        email: customer.email,
        birthday: birthday ? new Date(birthday) : undefined,
        gender: gender ? gender : undefined,
    }

    function validateField(
        elementId: string,
        value: string | boolean,
        validator: (value: string | boolean) => string | null
    ): boolean {
        const element = document.getElementById(elementId) as HTMLInputElement
        const error = validator(value)
        if (error) {
            element.classList.add("error")
            appendErrorMessage(element, error)
            newNotification({ html: error, class: "error" })
            return false
        }
        return true
    }
    function formatDate(dateString) {
        const date = new Date(dateString)
        // Korrigiert die Zeitzonenverschiebung
        const timezoneOffset = date.getTimezoneOffset() * 60000 // in ms
        const localISOTime = new Date(date.getTime() - timezoneOffset).toISOString().slice(0, 10)
        return localISOTime
    }
    function submitUser() {
        const validations = [
            { id: "firstName", value: personalData.firstName, validator: validateInput },
            { id: "lastName", value: personalData.lastName, validator: validateInput },
        ]

        let isValid = true
        for (const { id, value, validator } of validations) {
            // @ts-ignore
            if (!validateField(id, value, validator)) isValid = false
        }

        if (isValid) {
            customer.first_name = personalData.firstName
            customer.last_name = personalData.lastName
            console.log(personalData.birthday)
            updateCustomer($login.tokenData.tibiId, {
                id: customer.id,
                first_name: personalData.firstName,
                last_name: personalData.lastName,
                form_fields: [
                    {
                        name: "gender",
                        value: personalData.gender,
                        customer_id: customer.id,
                    },
                    {
                        name: "birthday",
                        value: personalData.birthday ? formatDate(personalData.birthday) : undefined,
                        customer_id: customer.id,
                    },
                ],
            }).then(() => (editMode = false))
        }
    }

    const genderOptions = [
        { label: "Männlich", value: "male" },
        { label: "Weiblich", value: "female" },
    ]
    let form: HTMLFormElement
</script>

<div class="wrapper">
    <CardWrapper>
        <form bind:this="{form}">
            <h3>Persönliche Daten</h3>
            <div class="row">
                <Input
                    onChange="{() => {}}"
                    bind:value="{personalData.email}"
                    placeholder="E-Mail*"
                    id="eMail"
                    disabled="{true}"
                    type="{editMode ? 'text' : 'noInput'}"
                />
            </div>
            <div class="row">
                <Input
                    onChange="{onChange}"
                    bind:value="{personalData.firstName}"
                    placeholder="Vorname*"
                    id="firstName"
                    type="{editMode ? 'text' : 'noInput'}"
                />
                <Input
                    onChange="{onChange}"
                    bind:value="{personalData.lastName}"
                    placeholder="Nachname*"
                    id="lastName"
                    type="{editMode ? 'text' : 'noInput'}"
                />
            </div>
            <div class="row">
                <Calendar
                    bind:dateValue="{personalData.birthday}"
                    placeholder="Geburtsdatum*"
                    id="birthday"
                    editMode="{editMode}"
                />
                <Select
                    bind:value="{personalData.gender}"
                    options="{genderOptions}"
                    placeholder="Gender*"
                    selectedOption="{{
                        label:
                            personalData.gender == 'male'
                                ? 'Männlich'
                                : personalData.gender == 'female'
                                ? 'Weiblich'
                                : null,
                        value: personalData.gender,
                    }}"
                    clearable="{true}"
                    editMode="{editMode}"
                />
            </div>
            {#if editMode}
                <div class="action-button-line">
                    <button
                        class="cta primary"
                        on:click|stopPropagation|preventDefault="{() => {
                            editMode = false
                            personalData.firstName = customer.first_name
                            personalData.lastName = customer.last_name
                            removeAllErrors(form)
                        }}">Änderungen verwerfen</button
                    >
                    <button
                        class="cta secondary"
                        on:click|stopPropagation|preventDefault="{submitUser}">Änderungen speichern</button
                    >
                </div>
            {:else}
                <button
                    class="action-line"
                    on:click|stopPropagation|preventDefault="{() => {
                        editMode = true
                    }}"
                >
                    <p>Angaben bearbeiten</p>

                    <span><Icon path="{mdiPencil}" /> </span>
                </button>
            {/if}
        </form>
    </CardWrapper>
</div>

<style lang="less">
    .wrapper {
        display: flex;
        width: 100%;
        flex-grow: 1;
        form {
            h3 {
                padding: 0px 2.4rem;
                color: var(--text-invers-100);
            }
            display: flex;
            flex-direction: column;
            gap: 24px;
            .row {
                padding: 0px 2.4rem;
                display: flex;
                gap: 24px;
            }
            .action-button-line,
            .action-line {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
            }
            .action-line {
                background: var(--bg-100);
                padding: 0.6rem 3.3rem 0.6rem 3.3rem;
                display: flex;
                flex-direction: row;
                align-items: center;
                height: 48px;
                justify-content: space-between;
                p,
                span {
                    color: var(--neutral-white);
                }
            }

            .action-button-line {
                height: 48px;
                display: flex;
                width: 100%;
                button {
                    width: 0px;
                    height: 100%;
                    flex-grow: 1;
                }
            }
        }
    }
</style>
